// import './assets/main.css'
import './assets/stylesheets/style.scss'
// import blog from './router/blog.json'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueLazyload from 'vue-lazyload'


import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(VueLazyload)
app.use(router)

// Object.values(blog)
// 	.map((e) => e.view)
// 	.forEach(
// 		async (e) => {
// 			var i = await import(`./views/blog/articles/${e}.vue`);
// 			console.log(e)
// 			console.log(i)
// 			app.component(e, i);
// 		}
// 	)
await router.isReady()

app.mount('#app')
